import { render, staticRenderFns } from "./PlayESport.vue?vue&type=template&id=4f2bb8bf&scoped=true&"
import script from "./PlayESport.vue?vue&type=script&lang=js&"
export * from "./PlayESport.vue?vue&type=script&lang=js&"
import style0 from "./PlayESport.vue?vue&type=style&index=0&id=4f2bb8bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2bb8bf",
  null
  
)

export default component.exports